import React from "react";
import { Alert, Card, Loader, ScrollArea, Stack, Title } from "@mantine/core"; // Add ScrollArea import
import { MediaAssetAdminUpload } from "./MediaAssetAdminUpload";
import { MediaAssetCard } from "./MediaAssetCard";
import { FailedAlert } from "../components/FailedAlert";
import { useGetMultiplacerMediaAssetsQuery } from "../../openapi";
import { useAppSelector } from "../app/hooks";
import { selectMissingKnownMediaAssetKeys } from "./mediaSelectors";
import "./mediaAssetsEnhancer";

export const AdminMediaAssetsPage: React.FC = () => {
  const { data = [], isLoading, isError, error } = useGetMultiplacerMediaAssetsQuery();
  const missingKeys = useAppSelector(selectMissingKnownMediaAssetKeys);

  return (
    <Card withBorder radius="md" p="md" w="100%" h="100%" style={{ overflow: "hidden" }}>
      <Stack gap="md" h="100%" style={{ overflow: "hidden" }}>
        {" "}
        {/* Keep this for now, but you can test removing overflow: "hidden" if needed */}
        <Title order={2}>Media assets</Title>
        {missingKeys.length > 0 && (
          <Alert color="yellow" variant="light" title="Mangler faste media assets">
            Følgende keys finnes ikke i databasen: {missingKeys.join(", ")}
          </Alert>
        )}
        <MediaAssetAdminUpload />
        {isLoading && <Loader />}
        {isError && <FailedAlert error={error} message="Klarte ikke å laste media assets." />}
        {/* Use ScrollArea for reliable scrolling */}
        <ScrollArea style={{ flex: 1 }}>
          <Stack gap="sm">
            {data.map((asset) => (
              <MediaAssetCard key={asset.key} asset={asset as any} />
            ))}
          </Stack>
        </ScrollArea>
      </Stack>
    </Card>
  );
};
